import React from 'react'
import { EnhancedReportContainer } from 'containers/Integrations/Reports/EnhancedReportContainer'

export const EnhancedReportPage = () => <EnhancedReportContainer />
